// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "snake" + "." + "8cd6d7bf" + ".chunk.css";
};